// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_o7-0";
export var discountCodeInput = "_o7-1";